<script>
import appConfig from "../../../app.config";
import axios from "axios";
import DataTable from "datatables.net-vue3";
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Nod Form",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role: localStorage.getItem("role"),
            title: "Nod Form",
            items: [{ text: "Nod Form", href: "/" }],
            payment_listing: [],
            loadingRoles: true,
            dtKey: 0, // Add dtKey to force DataTable re-render

            // Form data
            form: {
                file: null,
                amount: "",
                transaction_date: "",
                reference: "",
            },
        };
    },
  setup() {
        const {
            canCreateInstantPay
        } = usePermissions()
        return {
            canCreateInstantPay        
        };
    },
    methods: {
        handleFileUpload(event) {
            this.form.file = event.target.files[0];
        },

        async submitTransaction() {
            try {
                let formData = new FormData();
                formData.append("file", this.form.file);
                formData.append("amount", this.form.amount);
                formData.append("transaction_date", this.form.transaction_date);
                formData.append("reference", this.form.reference);

                axios.defaults.headers.common["authorization"] =
                    "Bearer " + localStorage.getItem("jwt");
                await axios.post(
                    process.env.VUE_APP_AR_API_BASEURL + "payment/nod/store" + "/" + this.$route.params.id,
                    formData,
                    {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );

                // Refresh table
                await this.getPaymentListing();
                this.dtKey += 1; // Increment dtKey to force DataTable re-render
                alert("Transaction saved successfully!");

                // Reset form
                this.form = {
                    file: null,
                    amount: "",
                    transaction_date: "",
                    reference: "",
                };
            } catch (error) {
                console.error(error);
                alert("Error saving transaction.");
            }
        },

        async getPaymentListing() {
            try {
                axios.defaults.headers.common["authorization"] =
                    "Bearer " + localStorage.getItem("jwt");
                const response = await axios.get(
                    process.env.VUE_APP_AR_API_BASEURL +
                        "customer/nod/list/" +
                        this.$route.params.id
                );
                this.loadingRoles = false;
                // Ensure reactivity by replacing the array
                this.payment_listing = [...response.data];
            } catch (error) {
                    this.loadingRoles = false;
                    this.messageBag = [error.error];
                console.error(error);
            }
        },
    },

    components: {
        DataTable,
    },

    mounted() {
        this.getPaymentListing();
    },
};

require("@/assets/css/datatable.css");
</script>

<template>
    <div class="card-body mb-5">
        <div class="live-preview">
            <div class="row align-items-center g-12">
                <div class="col-lg-12">
                    <div v-if="canCreateInstantPay">
                        <!-- Upload Form -->
                        <form
                            @submit.prevent="submitTransaction"
                            enctype="multipart/form-data"
                            class="mb-4"
                        >
                            <div class="row g-3">
                                <!-- File Upload -->
                                <!-- <div class="col-md-6">
                                    <label for="file" class="form-label"
                                        >Upload File</label
                                    >
                                    <input
                                        type="file"
                                        @change="handleFileUpload"
                                        class="form-control"
                                        required
                                    />
                                </div> -->

                                <!-- Amount RM -->
                                <div class="col-md-6">
                                    <label for="amount" class="form-label"
                                        >Amount (RM)</label
                                    >
                                    <input
                                        type="number"
                                        v-model="form.amount"
                                        class="form-control"
                                        step="0.01"
                                        placeholder="0.00"
                                        required
                                    />
                                </div>

                                <!-- Date Transaction -->
                                <div class="col-md-6">
                                    <label
                                        for="transaction_date"
                                        class="form-label"
                                        >Transaction Date</label
                                    >
                                    <input
                                        type="date"
                                        v-model="form.transaction_date"
                                        class="form-control"
                                        required
                                    />
                                </div>

                                <!-- Reference -->
                                <div class="col-md-6">
                                    <label for="reference" class="form-label"
                                        >Reference</label
                                    >
                                    <input
                                        type="text"
                                        v-model="form.reference"
                                        class="form-control"
                                        placeholder="Ref No."
                                        required
                                    />
                                </div>

                                <!-- Submit -->
                                <div
                                    class="col-md-2 d-flex align-items-end"
                                >
                                    <button
                                        type="submit"
                                        class="btn btn-primary w-100"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>

                        <!-- DataTable -->
                        <div class="table-responsive">
                            <DataTable
                                :options="{ lengthChange: false, ordering: false }"
                                :key="dtKey"
                                class="table table-striped table-nowrap mb-0"
                                id="example"
                            >
                                <thead class="table-secondary">
                                    <tr>
                                        <th>#.</th>
                                        <th scope="col">Payment Id</th>
                                        <th scope="col">Payment Date</th>
                                        <th scope="col">Payment Type</th>
                                        <th scope="col">Amount (RM)</th>
                                        <th scope="col">Pay Status</th>
                                        <th scope="col">Overpaid (RM)</th>
                                        <th scope="col">Invoice</th>
                                        <th scope="col">
                                            Payment Description
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr
                                        v-for="(item, index) in payment_listing"
                                        :key="index"
                                        class="content"
                                    >
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.payment_id }}</td>
                                        <td>{{ item.payment_date }}</td>
                                        <td>{{ item.payment_type }}</td>
                                        <td>{{ item.amount }}</td>
                                        <td>{{ item.status }}</td>
                                        <td>
                                            {{
                                                item.over_paid
                                                    ? item.over_paid.total_amount
                                                    : 0
                                            }}
                                        </td>
                                        <td>
                                            <span
                                                v-if="
                                                    item.invoices &&
                                                    item.invoices.length
                                                "
                                            >
                                                <span
                                                    v-for="(
                                                        invoice, i
                                                    ) in item.invoices"
                                                    :key="i"
                                                >
                                                    {{ invoice.invoice_no
                                                    }}<span
                                                        v-if="
                                                            i <
                                                            item.invoices
                                                                .length -
                                                                1
                                                        "
                                                        >,
                                                    </span>
                                                </span>
                                            </span>
                                            <span v-else>-</span>
                                        </td>
                                        <td>
                                            {{ item.payment_description }}
                                        </td>
                                    </tr>
                                </tbody>
                            </DataTable>
                        </div>
                    </div>
                    <div v-else class="text-center text-muted p-4">
                        You Dont Have Permission To View This Page
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>